module.exports = __webpack_public_path__ + "assets/all_follow.png";